import { ManagedRuntime } from 'effect'

import { TechnicalBrowserLayer } from '#di/browser/browser.layer.ts'
import { appMemoMap } from '#runtime/shared.memo-map.ts'

export const InstrumentationBrowserRuntime = ManagedRuntime.make(
  TechnicalBrowserLayer,
  { memoMap: appMemoMap },
)
